import { Modal, ModalBody, ModalButtons, ModalContent, ModalHeader, ModalHeaderTitle } from "@ui/common/Modal"
import { Button } from "@ui/common/buttons/Button"
import { CheckBox } from "@ui/common/form/CheckBox"
import React from "react"

export function EmptyWorkOrderModal({
    isVisible,
    doNotShowAgain,
    onDoNotShowAgainChanged,
    onCancelClick,
    onConfirmClick,
}: {
    isVisible: boolean
    doNotShowAgain: boolean
    onDoNotShowAgainChanged: (isChecked: boolean) => void
    onCancelClick: () => void
    onConfirmClick: () => void
}): JSX.Element {
    return (
        <Modal useContentTag={true} isVisible={isVisible} isClosable={false}>
            <ModalContent>
                <ModalHeader>
                    <ModalHeaderTitle>Empty Work Order</ModalHeaderTitle>
                </ModalHeader>
                <ModalBody>
                    <div>No Service Items have been added to the Work Order. Is this correct?</div>
                    <CheckBox
                        style={{ marginTop: "16px" }}
                        label={"Do not show this popup again."}
                        isChecked={doNotShowAgain}
                        onCheckChanged={onDoNotShowAgainChanged}
                    />
                </ModalBody>
                <ModalButtons>
                    <Button label={"Cancel"} onClick={onCancelClick} />
                    <Button label={"Confirm"} onClick={onConfirmClick} />
                </ModalButtons>
            </ModalContent>
        </Modal>
    )
}
